import type { ClockParts, Slide } from "./types";

export function isSlideAvailable(slide: Slide, clock: ClockParts, now = new Date()): boolean {
  if (!slide.enabled) return false;
  if (slide.daysOfWeek && !slide.daysOfWeek.includes(clock.dayOfWeek)) return false;
  if (slide.campaignStart && now < new Date(slide.campaignStart)) return false;
  if (slide.campaignEnd && now > new Date(slide.campaignEnd)) return false;
  const minutes = clock.hour * 60 + clock.minute;
  const parse = (value: string) => Number(value.slice(0, 2)) * 60 + Number(value.slice(3, 5));
  if (slide.availableFrom && minutes < parse(slide.availableFrom)) return false;
  if (slide.availableUntil && minutes >= parse(slide.availableUntil)) return false;
  return true;
}
